const semver = process.env.REACT_APP_BUILD_VERSION || '1.0.7';

export const APP_VERSION_SEMVER = semver;
export const APP_VERSION_LABEL = `v${semver}`;
